// Sezione "Dichiarazioni della cliente" — visualizza le risposte del
// questionario pre-analisi cute all'interno del dettaglio referto.
// Mostra solo le risposte effettivamente date. Sola lettura.

import React from "react";
import { MessageCircle } from "lucide-react";

// Etichetta umana della domanda + etichetta umana per ciascuna risposta.
// Stesso ordine, id e valori del questionario (CuteQuestionnaire.jsx),
// allineati a Trico_survay.py — coerenza visiva tra "compilazione" e "lettura".
const LABELS = [
  { id: "scalp_oiliness_answer",      label: "Untuosità cuoio capelluto",         answers: { normal: "Normale", oily: "Grasso", veryOily: "Molto grasso" } },
  { id: "scalp_hydration_answer",     label: "Idratazione cuoio capelluto",       answers: { normal: "Normale", dry: "Secco", veryDry: "Molto secco" } },
  { id: "scalp_sensitivity_answer",   label: "Cute sensibile",                    answers: { no: "No", yes: "Sì" } },
  { id: "scalp_flaking_answer",       label: "Forfora / scaglie",                 answers: { no: "No", yes_slightly: "Sì leggermente", yes_a_lot: "Sì molto" } },
  { id: "hair_strength_answer",       label: "Forza capelli",                     answers: { normal: "Normale", weak: "Debole", veryWeak: "Molto debole" } },
  { id: "hair_volume_answer",         label: "Volume capelli",                    answers: { normal: "Normale", low: "Basso", veryLow: "Molto basso" } },
  { id: "hair_loss_answer",           label: "Caduta capelli",                    answers: { no: "No", yes_slightly: "Sì leggermente", yes_a_lot: "Sì molto" } },
  { id: "hair_loss_family_answer",    label: "Familiarità caduta",                answers: { no: "No", yes: "Sì" } },
  { id: "shower_answer",              label: "Capelli su pettine / doccia",       answers: { veryLittle: "Pochi", moderate: "Moderati", abundant: "Abbondanti" } },
  { id: "accessories_answer",         label: "Capelli su vestiti o accessori",    answers: { no: "No", yes: "Sì" } },
  { id: "significant_stress_answer",  label: "Stress significativo",              answers: { no: "No", yes: "Sì" } },
  { id: "age_range_answer",           label: "Fascia d'età",                      answers: { _18_24: "18-24", _25_34: "25-34", _35_44: "35-44", _45_54: "45-54", _55_64: "55-64", _65_and_more: "65+" } },
];

export default function QuestionnaireDeclarations({ questionnaire }) {
  if (!questionnaire || Object.keys(questionnaire).length === 0) {
    return null;
  }

  const rows = LABELS
    .map((q) => ({ q, value: questionnaire[q.id] }))
    .filter((r) => r.value !== undefined && r.value !== null && r.value !== "");

  if (rows.length === 0) return null;

  return (
    <div
      className="col-span-12 rounded-2xl border border-[#E5E5E0] bg-white p-8 animate-fade-up"
      data-testid="questionnaire-declarations"
    >
      <div className="flex items-center gap-2 mb-5">
        <MessageCircle className="w-4 h-4 text-[#C5A059]" />
        <p className="text-xs uppercase tracking-wider text-[#C5A059] font-medium">
          Dichiarazioni della cliente
        </p>
      </div>
      <p className="text-sm text-[#737373] mb-6 leading-relaxed">
        Risposte raccolte nel questionario pre-analisi. Non sono visibili
        nel PDF cliente: restano come traccia di lavoro del parrucchiere.
      </p>

      <dl className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4">
        {rows.map(({ q, value }) => {
          const answerLabel = q.answers?.[value] || String(value);
          return (
            <div
              key={q.id}
              className="flex flex-col gap-1 py-2 border-b border-[#F0EFEA] last:border-b-0"
              data-testid={`declaration-${q.id}`}
            >
              <dt className="text-[11px] uppercase tracking-wider text-[#A3A3A3] font-medium">
                {q.label}
              </dt>
              <dd className="text-[15px] text-[#1A1A1A]">
                {answerLabel}
              </dd>
            </div>
          );
        })}
      </dl>
    </div>
  );
}
